var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticStyle:{"margin-inline":"auto","text-align":"center","max-width":"600px"}},[_vm._v(" Сервис предназначен для добавления пунктов приема вторичного сырья ")])])
}]

export { render, staticRenderFns }